import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import VuiBox from "components/ui/VuiBox";
import { useUIController, setLayout } from "context";

function PageLayout({ children, background, sx }) {
  const [, dispatch] = useUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);

  return (
    <VuiBox
      width="100vw"
      maxWidth="100%"
      height="100vh"
      minHeight="100vh"
      sx={({ functions: { tripleLinearGradient }, palette: { gradients }, breakpoints }) => ({
        overflowX: "hidden",
        overflowY: { xs: "auto", md: "hidden" },
        backgroundImage: background !== "default"
          ? background
          : tripleLinearGradient(
              gradients.cover.main,
              gradients.cover.state,
              gradients.cover.stateSecondary,
              gradients.cover.deg
            ),
        position: "relative",
        [breakpoints.down("sm")]: {
          height: "auto",
          minHeight: "100vh",
        },
        ...sx,
      })}
    >
      {children}
    </VuiBox>
  );
}

PageLayout.defaultProps = {
  background: "default",
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageLayout;
